// extracted by mini-css-extract-plugin
module.exports = {"title":"PostHeader_title__3igys"};